<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      is-list
      lazy
      :load="load"
      row-key="areaCode"
      :reset-data="resetData"
      serial-width="110"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:tableOperation>
        <el-col>
          <el-button
            v-permission:SettingBaseDataRegionIndex_Add
            type="primary"
            class="main-btn"
            @click="onAdd()"
            >{{ $t('SettingBaseDataRegion.newProvincial') }}</el-button
          >
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
          >
            <template slot-scope="scope">
              <template v-if="false" />

              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-permission:SettingBaseDataRegionIndex_AddChild
                :disabled="!scope.row.BJ_HAS_CHILD"
                type="text"
                @click="onAdd(scope.row)"
                >{{ $t('SettingBaseDataRegion.table.subordinateArea') }}</el-button
              >
              <el-button
                v-permission:SettingBaseDataRegionIndex_Edit
                type="text"
                class="edit-btn"
                @click="onEdit(scope.row)"
                >{{ $t('editText') }}</el-button
              >
              <el-button
                v-permission:SettingBaseDataRegionIndex_Delete
                type="text"
                class="delete-btn"
                @click="onDelete(scope.row)"
                >{{ $t('delText') }}</el-button
              >
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <!-- 新增/编辑弹窗 -->
    <DataForm ref="DataForm" @reFresh="reFresh" />
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { commonApi } from '@/api';
import DataForm from './components/DataForm.vue';
export default {
  name: 'SettingBaseDataRegionIndex',
  components: {
    DataForm,
  },
  mixins: [pageMiXin],
  data() {
    return {
      selection: false,
      queryApi: commonApi.getProvince,
      // 查询参数
      queryParams: {},

      labelList: [
        { label: 'SettingBaseDataRegion.table.code', prop: 'areaCode', isCheck: true, disabled: false },

        { label: 'SettingBaseDataRegion.table.name', prop: 'name', isCheck: true, disabled: false },
        { label: 'SettingBaseDataRegion.table.abbreviation', prop: 'shortName', isCheck: true, disabled: false },
        // { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false },

        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 300 },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    // this.$refs.BjPage.tableData = [{}];
  },
  methods: {
    resetData(d) {
      return d.map(e => {
        return {
          ...e,
          children: [],
          BJ_HAS_CHILD: true,
          BJ_PARENT_ID: null,
          level: 0,
          parentCode: 0,
        };
      });
    },
    load({ row }) {
      return new Promise((resolve, reject) => {
        const LEVEL = row.level + 1;
        const PARENT_CODE = row.areaCode;
        const PARENT_NAME = row.name;
        const HAS_CHILDREN = LEVEL < 1;
        commonApi
          .getCity({ areaCode: row.areaCode })
          .then(res => {
            const TEMP = (Array.isArray(res) ? res : []).map(e => {
              return {
                ...e,
                BJ_HAS_CHILD: HAS_CHILDREN,
                level: LEVEL,
                parentCode: PARENT_CODE,
                parentName: PARENT_NAME,
                BJ_PARENT_ID: PARENT_CODE,
              };
            });
            if (TEMP.length) {
              resolve(TEMP);
            } else {
              this.$message.warning(this.$t('SettingBaseDataRegion.msgWarning'));
              reject();
            }
          });
      });
    },
    toRegion(row) {},
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.deleteApi({ id: row.id });
        })
        .catch(() => {});
    },
    /** 添加 */
    onAdd(row) {
      this.$refs.DataForm.show();
      if (row) {
        this.$nextTick(() => {
          this.$refs.DataForm.setForm({
            _innerMap: {},
            parentCode: row.areaCode,
            parentName: row.name,
            level: row.level + 1,
          });
        });
      }
    },
    /** 编辑操作 */
    onEdit(row) {
      this.$refs.DataForm.show(this.$lodash.clone(row));
    },
    deleteApi(API_DATA) {
      commonApi.deleteArea(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
